import AuthCli from './AuthCli'

/**
 * JavaScript version of the Report service API.
 */
export default class ReportCli {
  //
  // Path constants:
  //
  static get SERVICE_ROUTE() { return 'report' }

  static get DELAYED_PATH() { return 'delayed' }
  static get PRODUCT_CODES_QUERY() { return 'productcodes' }
    
  static get DOWNLOAD_FEEDBACK_REPORT_PATH() { return 'feedbackreport' }
  static get DOWNLOAD_FEEDBACK_REPORT_OF_BILLABLE_PATH () { return 'billablefeedbackreport' }
  static get INCLUDE_READ_QUERY() { return 'includeread' }
  static get INCLUDE_STATES_QUERY() { return 'includestates' }
  static get INCLUDE_PROOFS_QUERY() { return 'includeproofs' }
  static get INCLUDE_CERTS_QUERY() { return 'includecerts' }
  static get INCLUDE_DOCUMENTS_QUERY() { return 'includedocuments' }
  static get INCLUDE_REPORTS_QUERY() { return 'includereports' }
  static get INCLUDE_STAMPED_COPY_QUERY() { return 'includestampedcopy' }

  static get SHIPMENT_REPORT_PATH() { return 'shipmentsreport' }
  static get BILLABLE_SHIPMENT_REPORT_PATH() { return 'billableshipmentsreport' }  
  static get INCLUDE_EMITTED() { return 'includeemitted' }
  static get INCLUDE_PROGRAMMED() { return 'includeprogrammed' }
  static get INCLUDE_SAVED() { return 'includesaved' }
  static get FILTER_QUERY() { return 'filter' }
  static get BILLING_PATH() { return 'billing' }
  static get DOCUMENT_PATH() { return 'document' }
  static get BILLING_OF_BILLABLE_PATH() { return 'billablebilling' }
    
  // URL prefix for debugging environment vs behind reverse proxy environment.
  static get devPrefix() { return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:6019/' : window.location.protocol + '//' + window.location.host + '/api/' }
    
  /**
   * Calculates and provides the list of shipments considered delayed.
   * @param {string[]} productCodes Product codes of shipment to be filtered in
   * @returns 
   */
  static async GetDelayedShipments(productCodes) {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.DELAYED_PATH + '?' + this.PRODUCT_CODES_QUERY + '=' + productCodes.join()
    var body = null

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }


  /**
   * Generates the billing report for a given month.
   * @param {BillingReportArgs} arguments Input conditions
   */
  static async GetBillingReport(args) {
    var verb = 'POST'
    var path = this.SERVICE_ROUTE + '/' + this.BILLING_PATH 
    var body = args

    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }
       
  /**
   * Generates the billing report for a given month.
   * The report is provided as a downloadable file.
   * @param {BillingReportArgs} arguments Input conditions
   */
  static async DownloadBillingReport(args) {
    var verb = 'POST'
    var path = this.SERVICE_ROUTE + '/' + this.BILLING_PATH + this.DOCUMENT_PATH
    var body = args

    var fileName = null
    return fetch(this.devPrefix + path, AuthCli.GetRequestOptions(verb, body, false))
      .then(response => {

        if (response.status === 200) {
          const header = response.headers.get('Content-Disposition');
          const parts = header ? header.split(';') : null;
          fileName = parts ? parts[1].split('=')[1].replace(/"/g, '') : null;
          return response.blob()
        }
        else if (response.status === 500) return response.text()

      })
      .then(blobby => {
        if (blobby == null) return
        if (blobby.toString().startsWith('[ERR')) return blobby.toString()

        // Force the received content to appear as a downloaded file.
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = fileName ? fileName : "billing.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      });
  }
       

  /**
   * Generates and provides a .xls file of feedback returns available for the calling user.
   * @param {bool} includeRead Whether desired to receive return units flagged as read, otherwise only unread feedback will be included
   * @param {bool} includeStates Whether desired to receive state changes
   * @param {bool} includeProofs Whether desired to receive proofs of delivery
   * @param {bool} includeCerts Whether desired to receive certificates
   * @param {bool} includeDocuments Whether desired to receive documents
   * @param {bool} includeReports Whether desired to receive reports availability
   */
  static async DownloadFeedbackReport(includeRead, includeStates, includeProofs, includeCerts, includeDocuments, includeReports, includeStampedCopy) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.DOWNLOAD_FEEDBACK_REPORT_PATH + '?'
      + this.INCLUDE_READ_QUERY + '=' + includeRead + '&'
      + this.INCLUDE_STATES_QUERY + '=' + includeStates + '&'
      + this.INCLUDE_PROOFS_QUERY + '=' + includeProofs + '&'
      + this.INCLUDE_CERTS_QUERY + '=' + includeCerts + '&'
      + this.INCLUDE_DOCUMENTS_QUERY + '=' + includeDocuments + '&'
      + this.INCLUDE_REPORTS_QUERY + '=' + includeReports + '&'
      + this.INCLUDE_STAMPED_COPY_QUERY + '=' + includeStampedCopy
    
    var body = null

    var fileName = null
    return fetch(this.devPrefix + path, AuthCli.GetRequestOptions(verb, body, false))
      .then(response => {

       if (response.status === 200) {
          const header = response.headers.get('Content-Disposition');
          const parts = header ? header.split(';') : null;
          fileName = parts ? parts[1].split('=')[1].replace(/"/g, '') : null;
          return response.blob()
        }
        else if (response.status === 500) return response.text()

      })
      .then(blobby => {
        if (blobby == null) return
        if (blobby.toString().startsWith('[ERR')) return blobby.toString()

        // Force the received content to appear as a downloaded file.
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = fileName ? fileName : "feedback.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      });
  }

  /**
   * Generates and provides a .xls file of feedback returns available for any user in the current billable
   * @param {bool} includeRead Whether desired to receive return units flagged as read, otherwise only unread feedback will be included
   * @param {bool} includeStates Whether desired to receive state changes
   * @param {bool} includeProofs Whether desired to receive proofs of delivery
   * @param {bool} includeCerts Whether desired to receive certificates
   * @param {bool} includeDocuments Whether desired to receive documents
   * @param {bool} includeReports Whether desired to receive reports availability
   */
  static async DownloadFeedbackReportOfBillable(includeRead, includeStates, includeProofs, includeCerts, includeDocuments, includeReports, includeStampedCopy) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.DOWNLOAD_FEEDBACK_REPORT_OF_BILLABLE_PATH + '?'
      + this.INCLUDE_READ_QUERY + '=' + includeRead + '&'
      + this.INCLUDE_STATES_QUERY + '=' + includeStates + '&'
      + this.INCLUDE_PROOFS_QUERY + '=' + includeProofs + '&'
      + this.INCLUDE_CERTS_QUERY + '=' + includeCerts + '&'
      + this.INCLUDE_DOCUMENTS_QUERY + '=' + includeDocuments + '&'
      + this.INCLUDE_REPORTS_QUERY + '=' + includeReports + '&'
      + this.INCLUDE_STAMPED_COPY_QUERY + '=' + includeStampedCopy
    
    var body = null

    var fileName = null
    return fetch(this.devPrefix + path, AuthCli.GetRequestOptions(verb, body, false))
      .then(response => {

        if (response.status === 200) {
          const header = response.headers.get('Content-Disposition');
          const parts = header ? header.split(';') : null;
          fileName = parts ? parts[1].split('=')[1].replace(/"/g, '') : null;
          return response.blob()
        }
        else if (response.status === 500) return response.text()

      })
      .then(blobby => {
        if (blobby == null) return
        if (blobby.toString().startsWith('[ERR')) return blobby.toString()

        // Force the received content to appear as a downloaded file.
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = fileName ? fileName : "feedback.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      });
  }

  /**
    * Generates and provides a excel file containing shipments stored for the calling user in the current billable..
    * The calling user must be the owner of the shipment 
    * @param {bool} includeemitted If activated the service will provide already emitted shipments
    * @param {bool} includeprogrammed If activated the service will provide shipments programmed for future emission
    * @param {bool} includesaved If activated the service will provide shipments not yet emitted
    * @param {ShipmentFilter} filter Conditions for those shipments to be included. Pass null for no filter
    * @returns {byte[]} The content of the file for browser download
  */
  static async DownloadShipmentsReport(includeemitted, includeprogrammed, includesaved, filter) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.SHIPMENT_REPORT_PATH + "?" +
      this.INCLUDE_EMITTED + "=" + includeemitted + "&" +
      this.INCLUDE_PROGRAMMED + "=" + includeprogrammed + "&" +
      this.INCLUDE_SAVED + "=" + includesaved + "&" +
      this.FILTER_QUERY + "=" + JSON.stringify(filter)
    
    var body = null
    var fileName = null
    
    return fetch(this.devPrefix + path, AuthCli.GetRequestOptions(verb, body, false))
      .then(response => {

        if (response.status === 200) {
          const header = response.headers.get('Content-Disposition');
          const parts = header ? header.split(';') : null;
          fileName = parts ? parts[1].split('=')[1].replace(/"/g, '') : null;
          return response.blob()
        }
        else if (response.status === 500) return response.text()

      })
      .then(blobby => {
        if (blobby == null) return
        if (blobby.toString().startsWith('[ERR')) return blobby.toString()

        // Force the received content to appear as a downloaded file.
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = fileName ? fileName : "shipments.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      });
  }

  /**
    * Generates and provides a XLS file containing shipments info.
    * The calling user must be billable admin of the shipment
    * @param {bool} includeemitted If activated the service will provide already emitted shipments
    * @param {bool} includeprogrammed If activated the service will provide shipments programmed for future emission
    * @param {bool} includesaved If activated the service will provide shipments not yet emitted
    * @param {ShipmentFilter} filter Conditions for those shipments to be included. Pass null for no filter
    * @returns {byte[]} The content of the file for browser download
  */
  static async DownloadShipmentsReportOfBillable(includeemitted, includeprogrammed, includesaved, filter) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.BILLABLE_SHIPMENT_REPORT_PATH  + "?" +
      this.INCLUDE_EMITTED + "=" + includeemitted + "&" +
      this.INCLUDE_PROGRAMMED + "=" + includeprogrammed + "&" +
      this.INCLUDE_SAVED + "=" + includesaved + "&" +
      this.FILTER_QUERY + "=" + JSON.stringify(filter)
    
    var body = null
    var fileName = null
    
    return fetch(this.devPrefix + path, AuthCli.GetRequestOptions(verb, body, false))
      .then(response => {

        if (response.status === 200) {
          const header = response.headers.get('Content-Disposition');
          const parts = header ? header.split(';') : null;
          fileName = parts ? parts[1].split('=')[1].replace(/"/g, '') : null;
          return response.blob()
        }
        else if (response.status === 500) return response.text()

      })
      .then(blobby => {
        if (blobby == null) return
        if (blobby.toString().startsWith('[ERR')) return blobby.toString()

        // Force the received content to appear as a downloaded file.
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = fileName ? fileName : "shipments.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      });
  } 

  /**
    * Generates and provides a XLS file containing shipments info.
    * The calling user must be billable admin of the shipment
    * @param {bool} includeemitted If activated the service will provide already emitted shipments
    * @param {bool} includeprogrammed If activated the service will provide shipments programmed for future emission
    * @param {bool} includesaved If activated the service will provide shipments not yet emitted
    * @param {ShipmentFilter} filter Conditions for those shipments to be included. Pass null for no filter
    * @returns {byte[]} The content of the file for browser download
  */
  static async DownloadBillingReportOfBillableExcel(filter) {
    var verb = 'PUT'
    var path = this.SERVICE_ROUTE + '/' + this.BILLING_OF_BILLABLE_PATH  + "?" +
      this.FILTER_QUERY + "=" + JSON.stringify(filter)
    
    var body = null
    var fileName = null
    
    return fetch(this.devPrefix + path, AuthCli.GetRequestOptions(verb, body, false))
      .then(response => {

        if (response.status === 200) {
          const header = response.headers.get('Content-Disposition');
          const parts = header ? header.split(';') : null;
          fileName = parts ? parts[1].split('=')[1].replace(/"/g, '') : null;
          return response.blob()
        }
        else if (response.status === 500) return response.text()

      })
      .then(blobby => {
        if (blobby == null) return
        if (blobby.toString().startsWith('[ERR')) return blobby.toString()

        // Force the received content to appear as a downloaded file.
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let objectUrl = window.URL.createObjectURL(blobby);
        anchor.href = objectUrl;
        anchor.download = fileName ? fileName : "Facturacion.xlsx";
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      });
  } 
}


// WEBPACK FOOTER //
// ./src/sdk/ReportCli.js